import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'how-to-use-litbuy-spreadsheet', title: 'How to Use a LitBuy Spreadsheet Effectively' },
  { id: 'build-litbuy-spreadsheet', title: 'How to Build Your Own LitBuy Spreadsheet' },
  { id: 'litbuy-spreadsheet-features', title: 'LitBuy Spreadsheet Features Explained' },
];

export default function TemplatesPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['litbuy-spreadsheet-templates']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}